import { isNullOrUndefined } from "util";

export class HubspotLocationOnboarding {
  firstName: string;
  lastName: string;
  locationName: string;
  tagline: string;
  managersName: string;
  numUnits: number;
  occupancyRate: string;
  email: string;
  phone: string;
  address1: string;
  address2: string;
  hours: string;
  sitelinkCorpCode: string;
  sitelinkLocationCode: string;
  socialMedia: string;
  showSocialLinks = false;

  isFb = false;
  fbUrl: string = '';
  isTwitter = false;
  twitterUrl: string = '';
  isYelp = false;
  yelpUrl: string = '';
  isGoogle = false;
  google: string = '';
  isLinkedIn = false;
  linkedIn: string = '';
  isInsta = false;
  insta: string = '';
  isOther = false;
  otherSocial: string = '';

  id: string;
  origKey: string;

  constructor(data, id, origKey) {
    this.id = id;
    this.origKey = origKey;
    this.firstName = this.getValue(data.firstname);
    this.lastName = this.getValue(data.lastname);
    this.managersName = this.getValue(data.what_is_the_managers_name_location);
    this.numUnits = this.getValue(data.how_many_units_does_this_location_have_);
    this.occupancyRate = this.getValue(data.what_is_this_locations_current_occupancy_rate_);
    this.locationName = this.getValue(data.what_is_the_name_for_this_location_);
    this.tagline = this.getValue(data.location_tagline);
    this.email = this.getValue(data.what_is_the_email_for_this_location_);
    this.phone = this.getValue(data.location_phone_number) || this.getValue(data.phone);
    this.address1 = this.getValue(data.what_is_the_street_address_for_this_location_);
    this.address2 = this.getValue(data.what_is_the_city_state_and_zip_for_this_location_ie_knoxville_tn_37922_);
    this.hours = this.getValue(data.what_are_your_office_and_gate_hours_);
    this.sitelinkCorpCode = this.getValue(data.location_sitelink_corp_code);
    this.sitelinkLocationCode = this.getValue(data.location_sitelink_location_code);

    if (data.twitter_url) {
      this.twitterUrl = data.twitter_url.value;
      if (this.twitterUrl.indexOf('https://') == -1) {
        this.twitterUrl = "https://" + this.twitterUrl;
      }
    }
    if (data.yelp_url) {
      this.yelpUrl = data.yelp_url.value;
      if (this.yelpUrl.indexOf('https://') == -1) {
        this.yelpUrl = "https://" + this.yelpUrl;
      }
    }
    if (data.google_my_business_url) {
      this.google = data.google_my_business_url.value;
      if (this.google.indexOf('https://') == -1) {
        this.google = "https://" + this.google;
      }
    }
    if (data.linkedin_url) {
      this.linkedIn = data.linkedin_url.value;
      if (this.linkedIn.indexOf('https://') == -1) {
        this.linkedIn = "https://" + this.linkedIn;
      }
    }
    if (data.instagram_url) {
      this.insta = data.instagram_url.value;
      if (this.insta.indexOf('https://') == -1) {
        this.insta = "https://" + this.insta;
      }
    }
    this.otherSocial = this.getValue(data.name_of_other_social_media_outlets);
    if (data.facebook_url) {
      this.fbUrl = data.facebook_url.value;
      if (this.fbUrl.indexOf('https://') == -1) {
        this.fbUrl = "https://" + this.fbUrl;
      }
    }
    if (data.what_social_media_outlets_do_you_use_for_this_location) {
      this.socialMedia = data.what_social_media_outlets_do_you_use_for_this_location.value;
      let tmp = this.socialMedia.split("; ");
      for (let i of tmp) {
        if (i == 'Facebook') {
          this.isFb = true;
          this.showSocialLinks = true;
        }
        else if (i == 'Twitter') {
          this.isTwitter = true;
          this.showSocialLinks = true;
        }
        else if (i == 'Yelp') {
          this.isYelp = true;
          this.showSocialLinks = true;
        }
        else if (i == 'Google My Business') {
          this.isGoogle = true;
          this.showSocialLinks = true;
        }
        else if (i == 'Instagram') {
          this.isInsta = true;
          this.showSocialLinks = true;
        }
        else if (i == 'LinkedIn') {
          this.isLinkedIn = true;
          this.showSocialLinks = true;
        }
        else if (i == 'Other') {
          this.isOther = true;
          this.showSocialLinks = true;
        }
      }
    }
  }

  private getValue(input) {
    try {
      if (input) {
        return input.value;
      }
      else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/hubspot-location-from-onboarding.ts